import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie'
import Backbtn from './elements/Backbtn'
import { Footer, Nav, Loader, Analytics, Popupfilter } from './elements'

import { productFetchByType } from '../redux/actions'

class Productdetail extends Component {

    constructor(){
        super()
        this.state = {
            title: "",
            type: "",
            backSearch: "",
            isLogin: false,
            user: "",
            products: [],
            filter: {},
            isFilter: false,
        }
    }

    componentWillMount() {
        if(Cookies.get('user')){
            this.setState({
                isLogin: true,
                user: JSON.parse(Cookies.get('user'))
            })
        } else {
            window.location = "/login"
        }
        let params = this.getParams()
        this.props.productFetchByType(params.title, params.type)
        let type = ""
        if(params.type === "wall") type = "แอร์ผนัง"
        else if(params.type === "hang") type = "แอร์แขวน"
        else if(params.type === "four") type = "แอร์สี่ทิศทาง"
        else if(params.type === "concealed") type = "แอรเ์ปลือย"
        else if(params.type === "stand") type = "แอร์ตู้ตั้ง"
        else if(params.type === "one_way") type = "แอร์หนึ่งทิศทาง"
        this.setState({
            title: params.title,
            type,
            backSearch: "?title="+params.title+"&type_wall="+params.type_wall+"&type_hang="+params.type_hang+"&type_four="+params.type_four+"&type_concealed="+params.type_concealed+"&type_stand="+params.type_stand+"&type_one_way="+params.type_one_way
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.products) {
            this.setState({ products: nextProps.products })
        }
    }

    getParams() {
        const searchParams = new URLSearchParams(this.props.location.search);
        return {
            title: searchParams.get('title') || '',
            type: searchParams.get('type') || '',
            type_wall: searchParams.get('type_wall') || '',
            type_hang: searchParams.get('type_hang') || '',
            type_four: searchParams.get('type_four') || '',
            type_concealed: searchParams.get('type_concealed') || '',
            type_stand: searchParams.get('type_stand') || '',
            type_one_way: searchParams.get('type_one_way') || ''
        };
    }

    handleCloseFilter() {
        this.setState({ isFilter: false })
    }

    handleFilter(data) {
        const products = []
        if (
            data.air_type !== '' ||
            data.coil !== '' ||
            data.efficiency !== '' ||
            data.purify !== '' ||
            data.swing !== ''
        ) {
            let check = true;
            this.props.products.forEach(item => {
                for (let key in data) {
                    if (data[key] !== '' && data[key] !== item[key]) {
                        check = false
                    }
                }
                if (check) {
                    products.push(item)
                }
            })
            this.setState({ products })
        } else {
            this.setState({ products: this.props.products })
        }
        this.setState({ isFilter: false, filter: data })
    }

    showProducts() {
        if (this.state.products.length === 0 && Object.keys(this.state.filter).length !== 0) {
            return <p className="cant-find">ไม่พบสินค้า</p>
        } else if(this.state.products.length > 0 || Object.keys(this.state.filter).length !== 0) {
            return this.state.products.map((item, index) => {
                let price = 0;
                let product_code = '';
                /* eslint eqeqeq: 0 */
                if(this.state.user.rank == 1) price = item.price
                else if(this.state.user.rank == 2) {
                    price = item.price2
                    product_code = item.product_code
                } else if(this.state.user.rank == 3) price = item.price3
                else if(this.state.user.rank == 4) {
                    price = item.price4
                    product_code = item.product_code
                } else if(this.state.user.rank == 5) price = item.price5
                return (
                    // LINE send msg to Line@ onClick={()=>window.location = "line://oaMessage/@lineteamjp/HelloTest"}
                    <div className="each-detail" key={++index}>
                        <Analytics />
                        <div className="detail-left">
                            <div className="product-img">
                                <img src={item.img} alt="aircondition"/>
                            </div>
                        </div>
                        <div className="detail-right">
                            <h2 className="product-no">{item.title}</h2>
                            <h3>ราคา : <span className="price">{price}</span> บาท</h3>
                            {(item.inventory && <h4>สินค้าคงเหลือ : <span className="inventory">{item.inventory}</span></h4>)}
                            {(item.btu && <p>BTU/HR : <span className="btu">{item.btu}</span></p>)}
                            <div className="group-item">
                                {(item.com && <p>ประกันคอม : <span className="com">{item.com}</span> ปี</p>)}
                                {(item.spare && <p>อะไหล่ : <span className="spare">{item.spare ? item.spare : '-'}</span> ปี</p>)}
                            </div>
                            <div className="group-item">
                                {(item.air_type && <p>ระบบ : <span>{item.air_type}</span></p>)}
                                {(item.size && <p>ไซด์ท่อ : <span className="size">{item.size}</span></p>)}
                            </div>
                            {(item.efficiency && <p>เบอร์ 5 : <span>{item.efficiency}</span></p>)}
                            <div className="group-item">
                                {(item.coil && <p>คอยล์ : <span>{item.coil}</span></p>)}
                                {(item.swing && <p>สวิง : <span>{item.swing}</span></p>)}
                            </div>
                            <div className="group-item">
                                {(item.purify && <p>ฟอกอากาศ : <span>{item.purify}</span></p>)}
                                {(item.liquid && <p>น้ำยา : <span className="cleaner">{item.liquid}</span></p>)}
                            </div>
                            {(item.description && <p>รายละเอียด : <span>{item.description}</span></p>)}
                            {(product_code && <h4>รหัสสินค้า {product_code}</h4>)}
                        </div>
                        <div className="group-btn">
                            {(item.catalog && <div className="product-catalog">
                                <a href={item.catalog} target="_blank" rel="noopener noreferrer">แคตตาล็อก</a>
                                {/* <a href={item.catalog} target="_blank" rel="noopener noreferrer"><button>แคตตาล็อก</button></a> */}
                            </div>)}
                            <div className="product-catalog buy">
                                <a href={"line://oaMessage/@838tngkz/?สั่งซื้อ "+item.title}>สั่งซื้อ</a>
                                {/* <a href={"line://oaMessage/@838tngkz/?สั่งซื้อ "+item.title}><button style={{width: "83.03px"}}>สั่งซื้อ</button></a> */}
                            </div>
                        </div>
                    </div>
                )
            })
        } else {
            return <Loader />
        }
    }

    render() { 
        if(!this.state.isLogin) return <div></div>
        return ( 
            <div className="page-productdetail">
                {(this.state.isFilter && <Popupfilter data={this.state.filter} handleClose={() => this.handleCloseFilter()} handleFilter={(data) => this.handleFilter(data)} />)}
                <div className="productdetail-header">
                    <Backbtn backSearch={this.state.backSearch}/>
                    <div className="title">
                        <p>{this.state.title}</p>
                        <p className="air-type">{this.state.type}</p>
                    </div>
                    <Nav />
                </div>
                <div className="productdetail-detail container">
                    <div className="icon-filter">
                        <img src={require("../static/images/00_global/filter.png")} alt="filter" onClick={() => this.setState({ isFilter: true })}/>
                    </div>
                    {this.showProducts()}
                </div>
                <Footer />
            </div>
        )
    }
}
 
const mapStateToProps = ({ product }) => {
    return { 
        products: product.products
    }
}
 
export default connect(mapStateToProps, { productFetchByType })(Productdetail)